import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import EditUserRoleSkeleton from "./EditUserRoleSkeleton";

const LabelSkeleton = () => (
  <div className="mb-3">
    <Skeleton width={120} height={14} />
  </div>
);

const InputSkeleton = () => (
  <div className="mb-3">
    <Skeleton width={"100%"} height={36} />
  </div>
);

const EditUserSkeleton = () => {
  return (
    <div className="container-fluid p-3 bg-light">
      <div className="row mb-4">
        <div className="col-md-4">
          {Array.from({ length: 6 }).map((_, idx) => (
            <LabelSkeleton key={idx} />
          ))}
        </div>

        <div className="col-md-8">
          {Array.from({ length: 4 }).map((_, idx) => (
            <InputSkeleton key={idx} />
          ))}
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-md-4">
          <Skeleton width={120} height={14} />
        </div>
        <div className="col-md-8">
          <Skeleton width={36} height={36} />
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-md-4" />
        <div className="col-md-8">
          <EditUserRoleSkeleton />
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-md-8 offset-md-4 d-flex gap-2">
          <Skeleton width={100} height={36} />
          <Skeleton width={80} height={36} />
        </div>
      </div>
    </div>
  );
};

export default EditUserSkeleton;
